import { createReducer } from 'utils/redux'

const INITIAL_STATE = {
  loadCostInBytes: 0,
  initTimestamp: null,
  timeByName: {}
}

const handleReceiveMarkedtime = ({ action, draft }) => {
  draft.timeByName[action.payload.name] = action.payload.time
}

const receiveInitTimestampHandler = ({ action, draft }) => {
  draft.initTimestamp = action.payload
}

const receiveServerResponseSizeHandler = ({ action, draft }) => {
  const { size } = action.payload

  draft.loadCostInBytes += size
}

const actions = {
  RECEIVE_MARKED_TIME: handleReceiveMarkedtime,
  RECEIVE_INIT_TIMESTAMP: receiveInitTimestampHandler,
  RECEIVE_SERVER_RESPONSE_SIZE: receiveServerResponseSizeHandler
}

export default createReducer(
  INITIAL_STATE,
  actions
)
